module.exports = "img/taller-alm-1.0125f8.jpg";